
import { larryMediaArray } from './larryMedia'
import { leonReviewerProfile } from './larryReviewers'
import { larryBio, leonBio } from './larryBios'
import { larryDatingProfileHinge, larryDatingProfileBumble, larryDatingProfileTinder } from './larryDatingProfiles'

export const larryUser = {
  _id: 'larryUserId',
  email: 'larry@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...leonReviewerProfile }
  ],
  media: [ ...larryMediaArray ],
  bio: { ...larryBio },
  datingProfiles: [
    { ...larryDatingProfileHinge },
    { ...larryDatingProfileBumble },
    { ...larryDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const leonUser = {
  _id: 'leonUserId',
  email: 'leon@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...leonBio },
  datingProfiles: [],
  reviewerProfile: { ...leonReviewerProfile },
}
